import { GetRepeatableSpaceBase } from '../types/GetRepeatableSpaceBase';
import { fillUtilityProps } from '../utils/fillUtilityProps';
import { isUndefinedSpace } from '../utils/isUndefinedSpace';
import { prepareInnerContext } from '../utils/prepareInnerContext';
import { getRepeatableSpaceByEntity } from './getRepeatableSpaceByEntity';
import { getRepeatableSpaceGeneral } from '../entities/general/getRepeatableSpaceGeneral';

const getRepeatableSpacePrev: GetRepeatableSpaceBase = (
  group,
  space,
  context,
) => {
  const contextInner = prepareInnerContext(context);

  // first try to get key by entity
  const byEntity = getRepeatableSpaceByEntity(group, space, contextInner);
  if (!isUndefinedSpace(byEntity)) return byEntity;

  // then search in general
  return getRepeatableSpaceGeneral(group, space, contextInner);
};

export const getRepeatableSpace: GetRepeatableSpaceBase = (
  group,
  space,
  context,
) => {
  const res = getRepeatableSpacePrev(group, space, context);
  return fillUtilityProps(res);
};
